import "@/entities/sentry"
import "./index.css"
import { createRoot } from "react-dom/client"

// import { Maintenance } from "./app/maintenance"
import { App } from "./app"
import { StrictMode } from "react"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)

// createRoot(document.getElementById("root")!).render(<Maintenance />)
